import { useState, useEffect, useCallback } from 'react';

import { useQuery, keepPreviousData } from '@tanstack/react-query';

export default function usePagination({
  queryKey,
  queryFn,
  perPage = 10,
  queryFnArgs = {},
  enabled = true,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageTotal, setPageTotal] = useState(1);

  const { data, isFetching, refetch } = useQuery({
    queryKey: [...queryKey, currentPage],
    queryFn: () => {
      return queryFn({ ...queryFnArgs, page: currentPage, limit: perPage });
    },
    placeholderData: keepPreviousData,
    enabled,
  });

  useEffect(() => {
    if (data) {
      setPageTotal(data.pageTotal);
    }
  }, [data]);

  const switchToPage = useCallback(
    (selected) => {
      const page = selected.selected + 1;
      if (page < 1 || page > pageTotal) {
        return;
      }

      setCurrentPage(page);
    },
    [pageTotal]
  );

  return {
    currentPage,
    switchToPage,
    pageTotal,
    data,
    isFetching,
    refetch,
  };
}
